import { createSharedComposable, useScrollLock } from '@vueuse/core'

let totalLockCount = 0

export const useLockScroll = createSharedComposable(() => {
  const isLocked = useScrollLock(() => document.body)

  const lock = () => {
    if (!totalLockCount) {
      isLocked.value = true
    }
    totalLockCount++
  }

  const unlock = () => {
    totalLockCount--

    if (!totalLockCount) {
      isLocked.value = false
    }
  }

  return {
    lock,
    unlock
  }
})
